module.exports = __webpack_public_path__ + "assets/img/tx13g_3.331c4ba2.jpg";